import script from "./File2.vue?vue&type=script&setup=true&lang=js"
export * from "./File2.vue?vue&type=script&setup=true&lang=js"

import "./File2.vue?vue&type=style&index=0&id=67bd1813&lang=less"

const __exports__ = script;

export default __exports__